var normalizeComponent = require("!../../../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./ntko-attachment.vue"
import __vue_script__ from "!!babel-loader!../../../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./ntko-attachment.vue"
/* template */
import __vue_template__ from "!!../../../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a82a5d5a\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=template&index=0!./ntko-attachment.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modules/index/components/public-dialog/ntko/ntko-attachment.vue
// module id = 1168
// module chunks = 0 1